export interface EnvConfigs {
    readonly BASE_URL: string;
}

export class Configs {
    public static readonly DEV: EnvConfigs = {
        BASE_URL: "http://localhost:8000"
    };

    public static readonly PROD: EnvConfigs = {
        BASE_URL: "https://api-eod.binna.app"
    };

    static get env(): EnvConfigs {
        return process.env.NODE_ENV === "production" ? Configs.PROD : Configs.DEV;
    }

    
}
